// extracted by mini-css-extract-plugin
module.exports = {"job-quick-info":"job-quick-info_job-quick-info__WNz0B","item":"job-quick-info_item__cMCMV"};